var _path, _path2, _g, _rect, _rect2, _circle, _circle2, _circle3, _rect3, _path3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 109C25 73.1015 54.1015 44 90 44C125.899 44 155 73.1015 155 109V161.647C155 162.947 153.947 164 152.647 164H27.3529C26.0534 164 25 162.947 25 161.647V109Z",
    fill: "#E1E6E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_37",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 109C25 73.1015 54.1015 44 90 44C125.899 44 155 73.1015 155 109V161.647C155 162.947 153.947 164 152.647 164H27.3529C26.0534 164 25 162.947 25 161.647V109Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_37)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 43,
    width: 132,
    height: 122,
    fill: "#84FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 124H35V151H25V124Z",
    fill: "#0040AE",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 155H155V160H25V155Z",
    fill: "#0040AE",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 124,
    width: 9,
    height: 27,
    fill: "#0040AE",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.3,
    y: 52,
    width: 54.9,
    height: 16.1835,
    fill: "#0040AE",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.8,
    y: 52,
    width: 54.9,
    height: 16.1835,
    fill: "#0040AE",
    fillOpacity: 0.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 124,
    width: 8,
    height: 27,
    fill: "#0040AE",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 124,
    width: 36,
    height: 27,
    fill: "#0040AE",
    fillOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 138,
    r: 8,
    fill: "white",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 138,
    r: 12,
    fill: "black",
    fillOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 138,
    r: 8.16,
    fill: "black",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111 81H70L61 119H111V113H119L117 81H111Z",
    fill: "#0040AE",
    fillOpacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 97,
    r: 15,
    fill: "black",
    fillOpacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 97,
    r: 12,
    fill: "black",
    fillOpacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 90,
    r: 2,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot3);
export default __webpack_public_path__ + "static/media/bot-3.4f595546a806e30964dcf1ce159b2dcf.svg";
export { ForwardRef as ReactComponent };